/* Up/down arrows for the vertical product-gallery thumbnail rail.
   Runs at every width. pdp-mobile-density.css pins the rail to the main image's
   height and makes it scroll; these arrows are the affordance for that. They only
   appear when the rail actually overflows, and hide again at either end. Desktop
   needs them too: the theme caps the rail at a hardcoded 45rem that does not match
   the image height, so a 16-image product overflowed with no way to scroll.
   Spec: docs/superpowers/specs/2026-10-13-product-page-mobile-density-design.md */
(function () {
  var CHEVRON_UP = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6"/></svg>';
  var CHEVRON_DOWN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';

  function button(cls, label, svg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pdp-thumb-nav ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg;
    b.hidden = true;
    return b;
  }

  function setup(scroller) {
    if (scroller.dataset.thumbNav === '1') return;
    var rail = scroller.closest('.product-gallery__thumbnail-list');
    if (!rail) return;
    scroller.dataset.thumbNav = '1';

    var up = button('pdp-thumb-nav--up', 'Previous images', CHEVRON_UP);
    var down = button('pdp-thumb-nav--down', 'More images', CHEVRON_DOWN);
    rail.appendChild(up);
    rail.appendChild(down);

    function step() {
      var t = scroller.querySelector('.product-gallery__thumbnail:not([hidden])');
      return t ? Math.round(t.getBoundingClientRect().height) + 16 : 72;
    }

    up.addEventListener('click', function () { scroller.scrollBy({ top: -step(), behavior: 'smooth' }); });
    down.addEventListener('click', function () { scroller.scrollBy({ top: step(), behavior: 'smooth' }); });

    function update() {
      var overflowing = scroller.scrollHeight - scroller.clientHeight > 2;
      var top = scroller.scrollTop;
      up.hidden = !overflowing || top <= 1;
      down.hidden = !overflowing || top + scroller.clientHeight >= scroller.scrollHeight - 1;
    }

    scroller.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
    // Images load late and change scrollHeight, so re-check once they settle.
    window.addEventListener('load', update);
    setTimeout(update, 400);
    setTimeout(update, 1500);
    update();
  }

  function init() {
    document.querySelectorAll('.product-gallery__thumbnail-scroller').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('resize', init);
})();
